export type Theme = 'light' | 'dark';

export const THEME_STORAGE_KEY = 'tools-theme';

export function resolveTheme(stored: string | null, prefersDark: boolean): Theme {
  if (stored === 'light' || stored === 'dark') {
    return stored;
  }
  return prefersDark ? 'dark' : 'light';
}

export function applyThemeClass(theme: Theme, root: HTMLElement = document.documentElement): void {
  root.classList.toggle('dark', theme === 'dark');
}

export function readStoredTheme(): Theme | null {
  try {
    const stored = localStorage.getItem(THEME_STORAGE_KEY);
    return stored === 'light' || stored === 'dark' ? stored : null;
  } catch {
    return null;
  }
}

export function persistTheme(theme: Theme): void {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, theme);
  } catch {
    // Ignore storage failures (private browsing, blocked storage).
  }
}

export function getInitialTheme(): Theme {
  if (typeof window === 'undefined') {
    return 'dark';
  }
  return resolveTheme(readStoredTheme(), window.matchMedia('(prefers-color-scheme: dark)').matches);
}
